import cn from 'classnames';

import css from './simple-tooltip.css';

export const SimpleTooltip: FC<{
    title: string;
    className?: string;
    position?: 'top' | 'bottom' | 'center';
}> = ({ className, title, position = 'top' }) => (
    <div className={cn(css.textTooltip, className, css[`textTooltip_${position}`])}>{title}</div>
);

export const simpleTTOuterClass = css.withTooltip;
